/**
 * Ryan O'Dowd
 * 2024-08-06
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, isDarkMode}) => {
  return {
    titleAndSwitch: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginVertical: 8,
    },
    dialogSectionWrapper: {
      flex: 1,
      marginBottom: 8,
      padding: 8,
      paddingTop: 0,
      borderWidth: globalScale * 3,
      borderColor: colors.primary,
      borderRadius: globalScale * 8,
    },
    disabledSection: { // @TODO: maybe use overlay instead because text and checkboxes should look disabled as well
      borderColor: colors.gray,
      backgroundColor: `${colors.lightGray}aa`,
    },
    dialogSectionTitle: {
      flex: 1,
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
      color: isDarkMode ? colors.white : colors.black,
    },
    subFiltersWrapper: {
      flex: 1,
      width: '100%',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
    checkboxWrapper: {
      flex: 1,
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    disabledText: {
      color: colors.gray,
    },
    descriptionText: {
      marginLeft: 8,
    },
  };
};

export default getStyles;
